
import { z } from "zod";

export interface Constituency {
  id: string;
  name: string;
  code: string; // Now includes country prefix (e.g., 'KY-BTW')
  country_code: string;
  active: boolean;
  created_at?: string;
  updated_at?: string;
}

export type FormValues = {
  name: string;
  code: string; // This will be the constituency part only (e.g., 'BTW')
  country_code: string;
  active: boolean;
};

export const constituencyFormSchema = z.object({
  name: z.string().min(2, { message: "Name must be at least 2 characters." }),
  code: z.string().min(2, { message: "Code must be at least 2 characters." }),
  country_code: z.string().min(1, { message: "Country is required." }),
  active: z.boolean()
});

// Helper functions for handling the new code format
export const getConstituencyPartFromCode = (fullCode: string): string => {
  const parts = fullCode.split('-');
  return parts.length > 1 ? parts.slice(1).join('-') : fullCode;
};

export const createFullConstituencyCode = (countryCode: string, constituencyPart: string): string => {
  return `${countryCode}-${constituencyPart}`;
};
